export default __webpack_public_path__ + "static/media/010-Jello.f50cfa4b.svg";